import Container from '../lib/gui/dom/Container';
import { mount, setChildren, unmount} from 'redom';
import Image from '../lib/gui/dom/Image';
import Span from '../lib/gui/dom/Span';
import { Dates } from '../../packages/dates'; 
import Utils from '../../utils/Utils';
import EpgPersistence from './EpgPersistence';

export default class ResumeController {
    constructor(){
        this.mainContainer = null;
        this.resumeTitle = null;
        this.resumeDescription = null;
        this.imageEvent = null;
        this.resumePreview = null;
        this.resumeMetadata = null;
        this.parentResume = null;
        this.parentElement = null;
    }

    /**
   *
   * @param {*} parentElement elemento que contiene al  componente.
   * @memberof ChannelController
   */
  initialise(parentElement) {
    this.parentElement =  parentElement;
    this.parentResume = new Container(null, { id: 'resumeContainer'});
    const resume = new Container(this.parentResume, { class: 'resume'});
    const resumeContainer = new Container(null, { class: 'resume-container'});
    const resumedataContainer = new Container(null, { class: 'resume-data-container resume-data-container-fullEpg'});
    const resumeDataLarge = new Container(null, { class: 'resume-data-large'});
    this.resumeTitle = new Container(null, {class: 'resume-title resume-title-epg-persistance'});
    const resumeInfo = new Container(null, {class: 'resume-info'});

    this.resumeMetadata = new Container(null, {class: 'resume-metadata'});
    this.resumeDescription = new Container(null, {class: 'resume-description block-with-text'});


    resumeInfo.addChild(this.resumeMetadata);
    resumeInfo.addChild(this.resumeDescription);
    resumeDataLarge.addChild(this.resumeTitle);
    resumeDataLarge.addChild(resumeInfo);
    resumedataContainer.addChild(resumeDataLarge);

    this.resumePreview = new Container(null, { class: 'resume-preview live'});
    this.resumePreview.setStyle({display:'none'});
    this.imageEvent = new Image(null, null);
    this.resumePreview.addChild(this.imageEvent);

    

    resumeContainer.addChild(resumedataContainer);
    resumeContainer.addChild(this.resumePreview);
    resume.addChild(resumeContainer);
    mount(document.getElementById(this.parentElement), this.parentResume.getRootElement());
    
  }

  destroy(){
    unmount(document.getElementById(this.parentElement), this.parentResume.getRootElement());
    this.mainContainer = null;
    this.resumeTitle = null;
    this.resumeDescription = null;
    this.imageEvent = null;
    this.resumePreview = null;
    this.resumeMetadata = null;
    this.parentResume = null;
    this.parentElement = null;
  }

  clean(){
    this.parentResume && this.parentResume.setStyle({display: 'none'});
  }


  setResume(event){
    if(event && (typeof event === 'object') && this.parentElement){

        // const att = this.parentResume.getAttrs();
        // console.log('[JONY]-att',  this.parentResume.getRootElement());
        if(this.parentResume.getRootElement() && this.parentResume.getRootElement().style && this.parentResume.getRootElement().style.display &&  this.parentResume.getRootElement().style.display =='none'){
            this.parentResume.setStyle({display: 'block'});
        }

        if(this.resumeMetadata){
            setChildren(this.resumeMetadata.getRootElement(), []);
        }

        const title  = event.name || '';
        const notAvailable = (title == '' || title === 'NA');

        let description = event.description || '';
        const imageEvent =  event.ext_eventimage_name|| null;
        const duration = event.duration ? Utils.formatDuration(event.duration) : null;
        // const year = event.ext_year || null;
        // const dvb_content = event.dvb_content || null;
        let date_begin, start= null;
        let date_end, end = null;
        let durationParsed = '';
        this.resumeTitle.setText(notAvailable ? EpgPersistence.getLabelNotAvailable() : title);
        if(description && typeof description === 'string'){
          description = Utils.cutPlayerString(description, 290);
        }
        if(!notAvailable){
          this.resumeDescription.setText(description);
        }else{
          this.resumeDescription.setText('');
        }
        
        this.resumePreview.setStyle({display:'none'});
       

        //Obteniedo los atributos
        if(!isNaN(event.date_begin)) {
            date_begin = EpgPersistence.needsOffset()
            ? new Dates()
              .unix(event.date_begin)
              .utcOffset(EpgPersistence.needsOffset(), false)
              .format('YYYY/MM/DD HH:mm:ss')
            : new Dates().unix(event.date_begin).format('YYYY/MM/DD HH:mm:ss');
            start = new Dates(date_begin, 'YYYY/MM/DD HH:mm:ss');
        }
        if(!isNaN(event.date_end)) {
            date_end = EpgPersistence.needsOffset()
            ? new Dates()
              .unix(event.date_end)
              .utcOffset(EpgPersistence.needsOffset(), false)
              .format('YYYY/MM/DD HH:mm:ss')
            : new Dates().unix(event.date_end).format('YYYY/MM/DD HH:mm:ss');
            end = new Dates(date_end, 'YYYY/MM/DD HH:mm:ss');
        }

        if(start && end){
            durationParsed = `${ EpgPersistence.needsOffset()? new Dates().unix(event.date_begin).utcOffset(EpgPersistence.needsOffset(),false).format('HH.mm') : new Dates().unix(event.date_begin).format('HH.mm')}hs a ${ EpgPersistence.needsOffset()? new Dates().unix(event.date_end).utcOffset(EpgPersistence.needsOffset(),false).format('HH.mm') : new Dates().unix(event.date_end).format('HH.mm')}hs`;
            this.resumeMetadata.addChild(this.getMeta(durationParsed));
        }
        // if(year){
        //     this.resumeMetadata.addChild(this.getMeta(year));
        // }
        // if(dvb_content){
        //     this.resumeMetadata.addChild(this.getMeta(dvb_content));
        // }
        if(duration && !notAvailable){
            this.resumeMetadata.addChild(this.getMeta(duration));
        }

    }
  }

  getMeta(text) {
        const span = new Span(null,{'class': 'resume-meta resume-meta-persistance'});
        span.setText(text);
        return span;
  }

}



// WEBPACK FOOTER //
// ./src/AAF/Nepg/ResumeController.js